<form
  class="conversion-form"
  [formGroup]="convertedForm"
>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Customer Id</mat-label>
    <input
      matInput
      formControlName="customerId"
    />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>First Name</mat-label>
    <input
      matInput
      formControlName="firstName"
    />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Last Name</mat-label>
    <input
      matInput
      formControlName="lastName"
    />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Domain</mat-label>
    <input
      matInput
      formControlName="domain"
    />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Company</mat-label>
    <input
      matInput
      formControlName="company"
    />
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Choose a Source</mat-label>
    <mat-select
      formControlName="bdSourceId"
      [matTooltip]="bdsourceTooltip"
      matTooltipPosition="above"
      #source
    >
      @for (source of leadGenSources; track source?.id) {
        <mat-option [value]="source.id">
          {{ source.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Choose a Qualification</mat-label>
    <mat-select formControlName="bdMatrixId">
      @for (matrix of catalogs?.matrix; track matrix?.id) {
        <mat-option [value]="matrix.id">
          {{ matrix.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Choose a Country</mat-label>
    <mat-select formControlName="bdCountryId">
      @for (country of catalogs?.country; track country?.id) {
        <mat-option [value]="country.id">
          {{ country.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Choose a Delay</mat-label>
    <mat-select formControlName="bdDelayId">
      @for (delay of catalogs?.delay; track delay?.id) {
        <mat-option [value]="delay.id">
          {{ delay.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="form-field-5"
    subscriptSizing="dynamic"
  >
    <mat-label>Choose an Industry</mat-label>
    <mat-select formControlName="bdIndustryId">
      @for (industry of catalogs?.industry; track industry?.id) {
        <mat-option [value]="industry.id">
          {{ industry.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (this.clientRepresentatives) {
    <mat-form-field
      appearance="outline"
      class="form-field-5"
      subscriptSizing="dynamic"
    >
      <mat-label>Choose a Client</mat-label>
      <mat-select formControlName="salesRepId">
        @for (client of clientRepresentatives?.representatives; track client?.clientContactId) {
          <mat-option [value]="client.clientContactId">
            {{ client.name + ' | ' + client.geographicZone }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (this.convertedForm.get('businessValue')?.value) {
    <mat-form-field
      appearance="outline"
      class="form-field-5"
      subscriptSizing="dynamic"
    >
      <mat-label>Score</mat-label>
      <input
        matInput
        formControlName="businessValue"
      />
    </mat-form-field>
  }
</form>

<div class="conversion-actions">
  <button
    mat-raised-button
    color="primary"
    [disabled]="!selectedInteraction || convertedForm.invalid"
    (click)="converted()"
  >
    Converted
  </button>
</div>
